import { Getters } from 'vuex-smart-module';
import ContactsState from './state';

export default class ContactsGetters extends Getters<ContactsState> {}
